import { useState } from "react";
import useSelect from "~components/Form/hooks/useSelect";

const useAll = (formikRef) => {
  const [isPessoaFisica, setIsPessoaFisica] = useState(false);

  const recebimentoSelect = useSelect("recebimento");
  const tipoPessoaSelect = useSelect("tipoPessoa");
  const prazoSelect = useSelect("prazo");
  const incotermsSelect = useSelect("incoterms");

  const [prazo, setPrazo] = useState(0);
  const [incoterms, setIncoterms] = useState(0);

  function onChangeTipoPessoa(e) {
    tipoPessoaSelect.upDateValue(e.value);
    tipoPessoaSelect.upDateDefaultValue(e || "");
    if(formikRef?.current) formikRef.current?.setFieldValue("tipo", e.value);

    let pessoaFisica = e.value == 1;

    setIsPessoaFisica(pessoaFisica);

    if(formikRef?.current) setTimeout(() => formikRef.current.setFieldTouched("tipo", true));
  }

  function onChangeRecebimento(e) {
    recebimentoSelect.upDateValue(e.value);
    recebimentoSelect.upDateDefaultValue(e || "");
    if(formikRef?.current){
      formikRef.current?.setFieldValue("recebimento", e.value);
      setTimeout(() => formikRef.current?.setFieldTouched("recebimento", true));
    }
  }

  function onChangePrazo(e) {
    prazoSelect.upDateValue(e.value);
    prazoSelect.upDateDefaultValue(e || "");
    if(formikRef?.current){
      formikRef.current?.setFieldValue("prazo", e.value);
      setTimeout(() => formikRef.current?.setFieldTouched("prazo", true));
    }
  }

  function onChangeIncoterms(e) {
    incotermsSelect.upDateValue(e.value);
    incotermsSelect.upDateDefaultValue(e || "");
    if(formikRef?.current){
      formikRef.current?.setFieldValue("incoterms", e.value);
      setTimeout(() => formikRef.current?.setFieldTouched("incoterms", true));
    }
  }

  return {
    onChangeTipoPessoa,
    onChangeRecebimento,
    tipoPessoaSelect,
    recebimentoSelect,
    isPessoaFisica,
    prazoSelect,
    onChangePrazo,
    prazo,
    setPrazo,
    incotermsSelect,
    incoterms,
    setIncoterms,
    onChangeIncoterms
  };
}

export default useAll;